import SuperFetchV2 from '../../superFetchV2';
import {
  FeatureFlagDeleteResponse,
  FeatureFlagHistoriesParams,
  FeatureFlagHistoriesResponse,
  FeatureFlagListResponse,
  FeatureFlagUpdateRequest,
  FeatureFlagUpdateResponse,
} from './types';

const BASE = '/feature-flags';
// 오류는 화면이 모달 안 · 표 위에서 직접 보여 준다
const requestOptions = { skipFullscreenLoader: true, skipErrorModal: true };

export const featureFlagApi = {
  getFlags: (): Promise<FeatureFlagListResponse> =>
    SuperFetchV2.get<unknown, FeatureFlagListResponse>(BASE, requestOptions),
  getHistories: (params: FeatureFlagHistoriesParams): Promise<FeatureFlagHistoriesResponse> =>
    SuperFetchV2.get<unknown, FeatureFlagHistoriesResponse>(BASE + '/histories', { ...requestOptions, params }),
  updateFlag: (ticketKey: string, body: FeatureFlagUpdateRequest): Promise<FeatureFlagUpdateResponse> =>
    SuperFetchV2.put<unknown, FeatureFlagUpdateResponse>(
      `${BASE}/${encodeURIComponent(ticketKey)}`,
      body,
      requestOptions,
    ),
  /** 덮어쓴 값 지우기 — 코드에 없는 키 정리. 사유는 본문으로 보낸다 */
  deleteFlag: (ticketKey: string, reason: string): Promise<FeatureFlagDeleteResponse> =>
    SuperFetchV2.delete<unknown, FeatureFlagDeleteResponse>(`${BASE}/${encodeURIComponent(ticketKey)}`, {
      ...requestOptions,
      data: { reason },
    }),
};
